var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{key:_vm.loading,attrs:{"value":_vm.role,"items":_vm.availableRoles,"disabled":_vm.disabled || _vm.loading},on:{"change":_vm.setRole}})
}
var staticRenderFns = []

export { render, staticRenderFns }